import React, { useState, useEffect, useRef } from "react";
import "./Css/ValuationEdit.css";
import "./Css/ValuationEdit-responsive.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Button } from "primereact/button";
import {
  InputNumber,
  InputNumberChangeEvent,
} from "primereact/inputnumber";
import { motion } from "framer-motion";
import { Fade } from "react-awesome-reveal";
import { goToTop } from "../../../../../Components/goToTop";
import Textarea from "../../../../../Components/TextArea";
import TextInput from "../../../../../Components/TextInput";
import DocumentViewModal from "../../../../../Components/DocumentViewModal";
import NumberInput from "../../../../../Components/NumberInput";
import FileInput from "../../../../../Components/FileInput";
import DocumentDownload from "./DocumentDownload";
import { getAppCurrencyType } from "../../../../../Utils/Common";

import {
  ValuationEditDetails,
  CoverPage,
  Section,
  SubSection,
  SubSectionItem,
  SectionItem,
  Contingency,
  DataForContingency,
  Preliminary,
  SectionSummary,
  Variation,
  DataForVariation,
  Summary,
} from "../../../../../Controllers/Types/ValuationEdit/ValuationEditInterface";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../Controllers/hooks";
import { getValuationEditDataByFolder } from "../../../../../Controllers/Thunks/ValuationEditThunks";
import {
  addContingency,
  addVariation,
  cretaeValuationEdit,
  deleteContingencyData,
  deleteVarationData,
  fixedValuation,
  updateContingency,
  updateVariation,
  valuationItemAddAndUpdate,
  valuationPrilliminieryAddAndUpdate,
} from "../../../../../Api/ValuationEditService";
import {
  checkFileOthers,
  checkNumber,
  checkText,
} from "../../../../../Utils/Validator";
import { SharedFolderBy } from "../../../SampleProjectData";

const ValuationEdit: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useRef<Toast>(null);
  const currencySymbol = getAppCurrencyType();

  const itemData = location.state.data as any;
  const address = itemData.address as string;
  // const serviceName = itemData.service_name as string;
  // const folderName = itemData.folder as string;
  const sharedBy = itemData.sharedBy as SharedFolderBy | null;

  const [dataState, setDataState] = useState<"Add" | "Edit">("Add");
  const [loading, setLoading] = useState<boolean>(false);
  const [showSideBar, setShowSideBar] = useState<boolean>(false);
  const [showDownloadModal, setShowDownloadModal] = useState<boolean>(false);

  const [valuationEditData, setValuationEditData] = useState<
    ValuationEditDetails[]
  >([]);
  const [selectedValuationEditData, setSelectedValuationEditData] =
    useState<ValuationEditDetails | null>(null);

  // folder id
  const [folderId, setFolderId] = useState<number>(0);
  /* Cover page */

  const [showCoverPage, setShowCoverpage] = useState<boolean>(true);
  const [coverPageData, setCoverPageData] = useState<CoverPage | null>(null);
  const [hasCoverPage, setHasCoverPage] = useState<boolean>(false);

  /* Sections */
  const [sectionData, setSectionData] = useState<Section[]>([]);
  const [showSection, setShowSection] = useState<boolean>(false);
  const [toggledSection, setToggledSection] = useState<boolean>(false);
  const [hasSection, setHasSection] = useState<boolean>(false);

  /* Sub section */
  const [toggledSubSection, setToggledSubSection] = useState<boolean>(false);
  const [showSubSection, setShowSubSection] = useState<boolean>(false);
  const [currentSection, setCurrentSection] = useState<Section | null>(null);
  const [hasSubSection, setHasSubSection] = useState<boolean>(false);

  /* Section item */
  const [hasSectionItem, setHasSectionItem] = useState<boolean>(false);
  const [showSectionItem, setShowSectionItem] = useState<boolean>(false);
  const [sectionItemEditable, setSectionItemEditable] =
    useState<boolean>(false);

  /* Sub section item */
  const [currentSubSection, setCurrentSubSection] = useState<SubSection | null>(
    null
  );
  const [showSubSectionItem, setShowSubSectionItem] = useState<boolean>(false);
  const [hasSubSectionItem, setHasSubSectionItem] = useState<boolean>(false);
  const [subSectionItemEditable, setSubSectionItemEditable] =
    useState<boolean>(false);

  /* Preliminaries */
  const [showPreliminaries, setShowPreliminaries] = useState<boolean>(false);
  const [preliminariesData, setPreliminariesData] = useState<Preliminary[]>([]);
  const [hasPreliminary, setHasPreliminary] = useState<boolean>(false);
  const [preliminaryEditable, setPreliminaryEditable] =
    useState<boolean>(false);

  /* Variation */
  const [showVariation, setShowVariation] = useState<boolean>(false);
  const [hasVariation, setHasVariation] = useState<boolean>(false);
  const [variationData, setVariationData] = useState<Variation | null>(null);
  const [selectedVariation, setSelectedVariation] =
    useState<DataForVariation | null>(null);
  const [variationNumber, setVariationNumber] = useState<string>("");
  const [variationAmount, setVariationAmount] = useState<number | null>(null);
  const [variationItemName, setVariationItemName] = useState<string>("");
  const [variationFile, setVariationFile] = useState<File | null>(null);
  const [variationFileName, setVariationFileName] = useState<string>("");
  const [variationNumberError, setVariationNumberError] = useState<string>("");
  const [variationAmountError, setVariationAmountError] = useState<string>("");
  const [variationItemNameError, setVariationItemNameError] =
    useState<string>("");
  const [variationFileError, setVariationFileError] = useState<string>("");
  const [showVariationModal, setShowVariationModal] = useState<boolean>(false);

  /* Contingency */
  const [showContingency, setShowContingency] = useState<boolean>(false);
  const [hasContingency, setHasContingency] = useState<boolean>(false);
  const [contingencyData, setContingencyData] = useState<Contingency | null>(
    null
  );
  const [selectedContingency, setSelectedContingency] =
    useState<DataForContingency | null>(null);
  const [contingencyItemName, setContingencyItemName] = useState<string>("");
  const [contingencyAmount, setContingencyAmount] = useState<number | null>(
    null
  );
  const [contingencyItemNameError, setContingencyItemNameError] =
    useState<string>("");
  const [contingencyAmountError, setContingencyAmountError] =
    useState<string>("");
  const [showContingencyModal, setShowContingencyModal] =
    useState<boolean>(false);

  /* Summary */
  const [showSummary, setShowSummary] = useState<boolean>(false);
  const [hasSummary, setHasSummary] = useState<boolean>(false);
  const [summaryData, setSummaryData] = useState<Summary | null>(null);

  /* Note */
  const [note, setNote] = useState<string>("");
  const [noteError, setNoteError] = useState<string>("");
  const [noteContent, setNoteContent] = useState<string>("");
  const [noteType, setNoteType] = useState<string>("");
  const [showNoteViewModal, setShowNoteViewModal] = useState<boolean>(false);
  const [showNoteModifyModal, setShowNoteModifyModal] =
    useState<boolean>(false);
  const [noteState, setNoteState] = useState<
    "Architect" | "Builder" | "Client" | null
  >(null);
  const [itemId, setItemId] = useState<number | null>(null);
  const [preliminaryId, setPreliminaryId] = useState<number | null>(null);

  /* Document view */
  const [showDocumentViewModal, setShowDocumentViewModal] =
    useState<boolean>(false);
  const [documentPath, setDocumentPath] = useState<string | null>(null);

  /* For user type permission */
  const [loginUserRoleName, setLoginUserRoleName] = useState<string>("");
  const [isArchitectEditable, setIsArchitectEditable] = useState<boolean>(false);
  const [isBuilderEditable, setIsBuilderEditable] = useState<boolean>(false);
  const [isClientEditable, setIsClientEditable] = useState<boolean>(false);
  const documentUrl = '';

  const [architectCompanyName, setArchitectCompanyName] = useState<string>("");
  const [builderCompanyName, setBuilderCompanyName] = useState<string>("");

  // const architectCompanyName = "EM assessment";
  // const builderCompanyName = "Ikonic assessment";

  //   login user data.
  useEffect(() => {
    if (location.state && location.state.folderId) {
      const folder_id = location.state.folderId as number;
      setFolderId(folder_id);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchCompanyName = async () => {
      try {
        const companyName = await Promise.resolve(
          localStorage.getItem("company_name")
        );
        if (companyName) {
          setArchitectCompanyName(companyName);
        } else {
          setArchitectCompanyName("");
        }
      } catch (error) {
        setArchitectCompanyName("");
      }
    };

    fetchCompanyName();
  }, []);

  const dispatch = useAppDispatch();

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    dispatch(getValuationEditDataByFolder(folderId));
  }, [dispatch, folderId]);

  // this is get data from state list and set projectlist
  const valuationEdit = useAppSelector(
    (state) => state.valuationEditSlice.valuationEditData
  );

  //   login user data.
  useEffect(() => {
    const fetchUserRoleName = async () => {
      try {
        const userTypeName = await Promise.resolve(
          localStorage.getItem("user_type_name")
        );

        if (userTypeName) {
          setLoginUserRoleName(userTypeName.toLowerCase());
        } else {
          setLoginUserRoleName("");
        }
      } catch (error) {
        setLoginUserRoleName("");
      }
    };

    fetchUserRoleName();
  }, []);

  //   login user role name
  useEffect(() => {
    if (loginUserRoleName === "architect") {
      setIsArchitectEditable(true);
    } else if (loginUserRoleName === "builder") {
      setIsBuilderEditable(true);
    } else if (
      loginUserRoleName === "commercial client" ||
      loginUserRoleName === "domestic client"
    ) {
      setIsClientEditable(true);
    }
  }, [loginUserRoleName]);

  useEffect(() => {
    const fetchData = async () => {
      setValuationEditData(valuationEdit?.valuation_edit_data!);
    };
    fetchData();
  }, [valuationEdit]);

  /* ******************************** Valuation ******************************** */
  useEffect(() => {
    const fetchData = async () => {
      if (valuationEditData && valuationEditData.length > 0) {
        if (selectedValuationEditData && selectedValuationEditData !== null) {
          const finndlist = valuationEditData.filter(
            (e) => e.id === selectedValuationEditData.id
          );
          if (finndlist && finndlist.length > 0) {
            setSelectedValuationEditData(finndlist[0]);
            setBuilderCompanyName(
              finndlist[0]?.data?.cover_page?.comapny?.company_name !== null
                ? finndlist[0]?.data?.cover_page?.comapny?.company_name!
                : finndlist[0]?.data?.cover_page?.comapny?.first_name!
            );
          } else {
            setSelectedValuationEditData(valuationEditData[0]);
            setBuilderCompanyName(
              valuationEditData[0]?.data?.cover_page?.comapny?.company_name !==
                null
                ? valuationEditData[0]?.data?.cover_page?.comapny?.company_name!
                : valuationEditData[0]?.data?.cover_page?.comapny?.first_name!
            );
          }
        } else {
          setSelectedValuationEditData(valuationEditData[0]);
          setBuilderCompanyName(
            valuationEditData[0]?.data?.cover_page?.comapny?.company_name !==
              null
              ? valuationEditData[0]?.data?.cover_page?.comapny?.company_name!
              : valuationEditData[0]?.data?.cover_page?.comapny?.first_name!
          );
        }
      }
    };
    fetchData();
  }, [valuationEditData]);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedValuationEditData) {
        if (selectedValuationEditData?.data) {
          if (
            selectedValuationEditData?.data?.cover_page &&
            selectedValuationEditData?.data?.cover_page != null
          ) {
            setCoverPageData(selectedValuationEditData?.data?.cover_page);
            setHasCoverPage(true);
          } else {
            setCoverPageData(null);
            setHasCoverPage(false);
          }

          if (
            selectedValuationEditData?.data?.section_data &&
            selectedValuationEditData?.data?.section_data?.length !== 0
          ) {
            setSectionData(selectedValuationEditData?.data?.section_data);
            setHasSection(true);
          } else {
            setSectionData([]);
            setHasSection(false);
          }

          if (
            selectedValuationEditData?.data?.priliminiery_data &&
            selectedValuationEditData?.data?.priliminiery_data?.length !== 0
          ) {
            setPreliminariesData(
              selectedValuationEditData?.data?.priliminiery_data
            );
            setHasPreliminary(true);
          } else {
            setPreliminariesData([]);
            setHasPreliminary(false);
          }

          if (
            selectedValuationEditData?.data?.variation_data &&
            selectedValuationEditData?.data?.variation_data !== null
          ) {
            setVariationData(selectedValuationEditData?.data?.variation_data);
            setHasVariation(true);
          } else {
            setVariationData(null);
            setHasVariation(false);
          }

          if (
            selectedValuationEditData?.data?.contingency_data &&
            selectedValuationEditData?.data?.contingency_data !== null
          ) {
            setContingencyData(
              selectedValuationEditData?.data?.contingency_data
            );

            setHasContingency(true);
          } else {
            setContingencyData(null);
            setHasContingency(false);
          }

          if (
            selectedValuationEditData?.data?.summary_data &&
            selectedValuationEditData?.data?.summary_data !== null
          ) {
            setSummaryData(selectedValuationEditData?.data?.summary_data);
            setHasSummary(true);
          } else {
            setSummaryData(null);
            setHasSummary(false);
          }
        }
      }
    };

    fetchData();
  }, [selectedValuationEditData]);

  const handleChangeValuationEdit = (data: ValuationEditDetails) => {
    setSelectedValuationEditData(data);
  };

  // database insert function to set as fixed
  const handleFixValuationEdit = () => {


    confirmDialog({
      message: `Are you sure you want to Fix this valuation${selectedValuationEditData?.valuation_edit_no}?`,
      header: "Confirm the fix valuation.",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: fixValuationEdit,
      dismissableMask: true,
      draggable: false,
      resizable: false,
    });
  };

  const fixValuationEdit = async () => {
    const data = await fixedValuation(selectedValuationEditData?.id!);
    if (data.statusCode === 200) {
      // call dispach event
      dispatch(getValuationEditDataByFolder(folderId));
      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Valuation fixed successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error fixing the valuation.",
          life: 3000,
        });
      }
    }
  };




  const handleAddValuation = () => {
    confirmDialog({
      message: `Are you sure you want to create new valuation?`,
      header: "Create new valuation",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: createNewValuationEdit,
      dismissableMask: true,
      draggable: false,
      resizable: false,
    });
  };



  const createNewValuationEdit = async () => {
    const data = await cretaeValuationEdit(valuationEdit?.id!);
    if (data.statusCode === 200) {
      // call dispach event
      dispatch(getValuationEditDataByFolder(folderId));
      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Valuation added successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error adding the valuation.",
          life: 3000,
        });
      }
    }
  };

  /* **************************************************************************** */

  /* ******************************** Cover page ******************************** */
  const handleShowCoverPage = () => {
    setShowCoverpage(true);

    setShowSection(false);
    setShowSubSection(false);
    setShowPreliminaries(false);
    setShowSubSectionItem(false);
    setShowContingency(false);
    setShowVariation(false);
    setShowSummary(false);

    setToggledSection(false);
    setToggledSubSection(false);

    setShowSideBar(false);
    setPreliminaryEditable(false);
    setSectionItemEditable(false);
    setSubSectionItemEditable(false);

    goToTop();
  };
  /* **************************************************************************** */

  /* ********************************* Section ********************************** */
  const handleShowSection = () => {
    setShowSection(true);

    setToggledSection(!toggledSection);
    setShowCoverpage(false);
    setShowSubSection(false);
    setShowPreliminaries(false);
    setShowSubSectionItem(false);
    setShowContingency(false);
    setShowVariation(false);
    setShowSummary(false);
    setShowSectionItem(false);

    setShowSideBar(false);
    setPreliminaryEditable(false);
    setSectionItemEditable(false);
    setSubSectionItemEditable(false);

    goToTop();
  };

  const calculateSectionTotal = (data: Section[]): number => {
    return data.reduce((total, item) => total + (item.section_amount || 0), 0);
  };
  /* **************************************************************************** */

  /* ******************************* Sub section ******************************** */
  const handleShowSubSection = async (section: Section) => {
    setCurrentSection(section);
    if (section?.sub_section_data?.length !== 0) {
      setHasSubSection(true);
      setToggledSubSection(!toggledSubSection);
    } else {
      setHasSubSection(false);
      setToggledSubSection(false);
    }

    if (section?.section_item_data?.length !== 0) {
      setHasSectionItem(true);
      setShowSectionItem(true);
    } else {
      setHasSectionItem(false);
      setShowSectionItem(false);
    }

    setShowSubSection(true);

    setShowSection(false);
    setShowCoverpage(false);
    setShowPreliminaries(false);
    setShowSubSectionItem(false);
    setShowContingency(false);
    setShowVariation(false);
    setShowSummary(false);
    setToggledSection(true);

    setShowSideBar(false);
    setPreliminaryEditable(false);
    setSectionItemEditable(false);
    setSubSectionItemEditable(false);

    goToTop();
  };

  const calculateSubSectionTotal = (data: SubSection[]): number => {
    return data.reduce(
      (total, item) => total + (item.sub_section_amount || 0),
      0
    );
  };
  /* **************************************************************************** */

  /* ******************************* Section item ******************************* */
  const calculateSumSectionItem = (
    data: SectionItem[],
    type: "architect" | "builder"
  ): number => {
    return data.reduce((total, item) => {
      const value =
        type === "architect"
          ? item.architect_data?.value
          : item.builder_data?.value;
      return total + (value || 0);
    }, 0);
  };

  const handleToggleSectionItemEditable = () => {
    setSectionItemEditable(!sectionItemEditable);
  };

  const handleModifySectionItemNote = (
    rowData: SectionItem,
    type: "Architect" | "Builder" | "Client"
  ) => {
    setShowNoteModifyModal(true);

    if (rowData) {
      setItemId(rowData?.item_id!);

      if (type === "Architect") {
        setNote(rowData?.architect_data?.note || "");
      } else if (type === "Builder") {
        setNote(rowData?.builder_data?.note || "");
      } else if (type === "Client") {
        setNote(rowData?.client_note || "");
      } else {
        setNote("");
      }
    }
  };
  /* **************************************************************************** */

  /* ******************************* Item common ******************************** */
  const ItemTableHeaderGroup = (
    <ColumnGroup>
      <Row>
        <Column
          header="Item no."
          alignHeader={"center"}
          rowSpan={2}
          style={{ width: "5%" }}
        />

        <Column header="Item name" rowSpan={2} style={{ width: "20%" }} />

        <Column
          header="Actual amount"
          alignHeader={"right"}
          rowSpan={2}
          style={{ width: "7%" }}
        />

        <Column
          header={architectCompanyName}
          alignHeader={"center"}
          colSpan={2}
          style={{ width: "16%" }}
        />

        <Column
          header={builderCompanyName}
          alignHeader={"center"}
          colSpan={2}
          style={{ width: "16%" }}
        />

        <Column
          header="Notes"
          alignHeader={"center"}
          colSpan={3}
          rowSpan={2}
          style={{ width: "36%" }}
        />
      </Row>

      <Row>
        <Column header="%" alignHeader={"center"} style={{ width: "8%" }} />

        <Column header="Value" alignHeader={"right"} style={{ width: "8%" }} />

        <Column header="%" alignHeader={"center"} style={{ width: "8%" }} />

        <Column header="Value" alignHeader={"right"} style={{ width: "8%" }} />
      </Row>
    </ColumnGroup>
  );

  const itemEditor = (options: any) => {
    switch (options?.field) {
      case "architect_data.percentage":
        return (
          <InputNumber
            value={options.value}
            onBlur={(e) => {
              const value = e.target.value.toString();
              editEventComplete(
                e,
                options.field,
                value,
                options.rowData.item_id
              );
            }}
            onKeyDown={(e) => e.stopPropagation()}
            mode="decimal"
            max={100}
            min={0}
            className="editable_number_input"
            useGrouping={false}
            suffix=""
            inputClassName="text-center"
          />
        );

      case "builder_data.percentage":
        return (
          <InputNumber
            value={options.value}
            onBlur={(e) => {
              const value = e.target.value.toString();
              editEventComplete(
                e,
                options.field,
                value,
                options.rowData.item_id
              );
            }}
            onKeyDown={(e) => e.stopPropagation()}
            mode="decimal"
            className="editable_number_input"
            suffix=""
            useGrouping={false}
            inputClassName="text-center"
          />
        );
      default:
        return null;
    }
  };

  const editEventComplete = async (
    e: any,
    fieldName: string,
    keyValue: string,
    itemId: number
  ) => {
    if (String(keyValue) !== "undefined") {
      const data = await valuationItemAddAndUpdate(
        selectedValuationEditData?.id!,
        itemId,
        fieldName,
        keyValue
      );

      setLoading(false);
      if (data.status === true) {
        // call dispach event
        dispatch(getValuationEditDataByFolder(folderId));
      }
    }
    e.preventDefault();
  };

  // item note save function
  const handleSaveItemNote = async (e: React.FormEvent) => {
    e.preventDefault();

    if (String(note) !== "") {
      const data = await valuationItemAddAndUpdate(
        selectedValuationEditData?.id!,
        itemId!,
        "note",
        note
      );

      setLoading(false);
      if (data.status === true) {
        // call dispach event
        dispatch(getValuationEditDataByFolder(folderId));

        setLoading(false);
        setShowNoteModifyModal(false);

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Note updated successfully.",
            life: 3000,
          });
        }
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating note.",
            life: 3000,
          });
        }
      }
    }
  };
  /* **************************************************************************** */

  /* ***************************** Sub section item ***************************** */
  const handleShowSubSectionItem = async (subSection: SubSection) => {
    setCurrentSubSection(subSection);

    if (subSection?.sub_section_item_data?.length !== 0) {
      setHasSubSectionItem(true);
    } else {
      setHasSubSectionItem(false);
    }

    setShowSubSectionItem(true);
    setShowSection(false);
    setShowCoverpage(false);
    setShowPreliminaries(false);
    setShowSubSection(false);
    setShowContingency(false);
    setShowVariation(false);
    setShowSummary(false);
    setShowSectionItem(false);

    setShowSideBar(false);
    setPreliminaryEditable(false);
    setSectionItemEditable(false);
    setSubSectionItemEditable(false);

    goToTop();
  };

  const calculateSumSubSectionItem = (
    data: SubSectionItem[],
    type: "architect" | "builder"
  ): number => {
    return data.reduce((total, item) => {
      const value =
        type === "architect"
          ? item.architect_data?.value
          : item.builder_data?.value;
      return total + (value || 0);
    }, 0);
  };

  const handleToggleSubSectionItemEditable = () => {
    setSubSectionItemEditable(!subSectionItemEditable);
  };

  const handleModifySubSectionItemNote = (
    rowData: SubSectionItem,
    type: "Architect" | "Builder" | "Client"
  ) => {
    setShowNoteModifyModal(true);
    setNoteState(type);
    if (rowData) {
      setItemId(rowData?.item_id!);

      if (type === "Architect") {
        setNote(rowData?.architect_data?.note || "");
      } else if (type === "Builder") {
        setNote(rowData?.builder_data?.note || "");
      } else if (type === "Client") {
        setNote(rowData?.client_note || "");
      } else {
        setNote("");
      }
    }
  };
  /* **************************************************************************** */

  /* ******************************* Preliminaries ****************************** */
  const handleShowPreliminaries = () => {
    setShowPreliminaries(true);

    setShowSection(false);
    setShowCoverpage(false);
    setShowSubSection(false);
    setShowSubSectionItem(false);
    setShowContingency(false);
    setShowVariation(false);
    setShowSummary(false);
    setShowSectionItem(false);

    setToggledSection(false);
    setToggledSubSection(false);

    setShowSideBar(false);
    setPreliminaryEditable(false);
    setSectionItemEditable(false);
    setSubSectionItemEditable(false);

    goToTop();
  };

  const PreliminariesTableHeaderGroup = (
    <ColumnGroup>
      <Row>
        <Column
          header="Item no."
          alignHeader={"center"}
          rowSpan={2}
          style={{ width: "5%" }}
        />

        <Column header="Item name" rowSpan={2} style={{ width: "20%" }} />

        <Column
          header="Actual amount"
          alignHeader={"right"}
          rowSpan={2}
          style={{ width: "7%" }}
        />

        <Column
          header={architectCompanyName}
          alignHeader={"center"}
          colSpan={2}
          style={{ width: "16%" }}
        />

        <Column
          header={builderCompanyName}
          alignHeader={"center"}
          colSpan={2}
          style={{ width: "16%" }}
        />

        <Column
          header="Notes"
          alignHeader={"center"}
          colSpan={3}
          rowSpan={2}
          style={{ width: "36%" }}
        />
      </Row>

      <Row>
        <Column header="%" alignHeader={"center"} style={{ width: "8%" }} />

        <Column header="Value" alignHeader={"right"} style={{ width: "8%" }} />

        <Column header="%" alignHeader={"center"} style={{ width: "8%" }} />

        <Column header="Value" alignHeader={"right"} style={{ width: "8%" }} />
      </Row>
    </ColumnGroup>
  );

  const handleTogglePreliminaryEditable = () => {
    setPreliminaryEditable(!preliminaryEditable);
  };

  const preliminaryEditor = (options: any) => {
    switch (options?.field) {
      case "architect_data.percentage":
        return (
          <InputNumber
            value={options.value}
            onBlur={(e) => {
              const value = e.target.value.toString();
              editEventCompletePreme(
                e,
                options.field,
                value,
                options.rowData.priliminiery_id
              );
            }}
            onKeyDown={(e) => e.stopPropagation()}
            mode="decimal"
            className="editable_number_input"
            useGrouping={false}
            suffix=""
            inputClassName="text-center"
          />
        );

      case "builder_data.percentage":
        return (
          <InputNumber
            value={options.value}
            onBlur={(e) => {
              const value = e.target.value.toString();
              editEventCompletePreme(
                e,
                options.field,
                value,
                options.rowData.priliminiery_id
              );
            }}
            onKeyDown={(e) => e.stopPropagation()}
            mode="decimal"
            className="editable_number_input"
            suffix=""
            useGrouping={false}
            inputClassName="text-center"
          />
        );
      default:
        return null;
    }
  };

  const editEventCompletePreme = async (
    e: any,
    fieldName: string,
    keyValue: string,
    priliminiery_id: number
  ) => {
    if (String(keyValue) !== "undefined") {
      const data = await valuationPrilliminieryAddAndUpdate(
        selectedValuationEditData?.id!,
        priliminiery_id,
        fieldName,
        keyValue
      );

      setLoading(false);
      if (data.status === true) {
        // call dispach event
        dispatch(getValuationEditDataByFolder(folderId));
      }
    }
    e.preventDefault();
  };

  const handleModifyPreliminaryNote = (
    rowData: Preliminary,
    type: "Architect" | "Builder" | "Client"
  ) => {
    setShowNoteModifyModal(true);
    setNoteState(type);
    if (rowData) {
      setPreliminaryId(rowData?.priliminiery_id!);

      if (type === "Architect") {
        setNote(rowData?.architect_data?.note || "");
      } else if (type === "Builder") {
        setNote(rowData?.builder_data?.note || "");
      } else if (type === "Client") {
        setNote(rowData?.client_note || "");
      } else {
        setNote("");
      }
    }
  };

  // Save Preliminary into database
  const handleSavePreliminaryNote = async (e: React.FormEvent) => {
    e.preventDefault();

    if (String(note) !== "") {
      setLoading(true);
      const data = await valuationPrilliminieryAddAndUpdate(
        selectedValuationEditData?.id!,
        preliminaryId!,
        "note",
        note
      );

      setLoading(false);
      if (data.status === true) {
        // call dispach event
        dispatch(getValuationEditDataByFolder(folderId));

        setLoading(false);
        setShowNoteModifyModal(false);

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Note updated successfully.",
            life: 3000,
          });
        }
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating note.",
            life: 3000,
          });
        }
      }
    }
  };

  const calculateSumPreliminary = (
    data: Preliminary[],
    type: "architect" | "builder"
  ): number => {
    return data.reduce((total, item) => {
      const value =
        type === "architect"
          ? item.architect_data?.value
          : item.builder_data?.value;
      return total + (value || 0);
    }, 0);
  };
  /* **************************************************************************** */

  /* ******************************** Variation ********************************* */
  const handleShowVariation = () => {
    setShowVariation(true);

    setShowSection(false);
    setShowCoverpage(false);
    setShowSubSection(false);
    setShowSubSectionItem(false);
    setShowPreliminaries(false);
    setShowContingency(false);
    setShowSummary(false);
    setShowSectionItem(false);

    setToggledSection(false);
    setToggledSubSection(false);

    setShowSideBar(false);
    setPreliminaryEditable(false);
    setSectionItemEditable(false);
    setSubSectionItemEditable(false);

    goToTop();
  };

  const handleCloseVariationModal = () => {
    setShowVariationModal(false);
  };

  const handleAddVariation = () => {
    setShowVariationModal(true);
    setDataState("Add");

    setSelectedVariation(null);
    handleClearVariationFields();
  };

  // VAIDATIONS VARATION
  useEffect(() => {
    checkText(variationNumber, false, setVariationNumberError);
  }, [variationNumber]);

  useEffect(() => {
    checkNumber(variationAmount!, false, setVariationAmountError);
  }, [variationAmount]);

  useEffect(() => {
    checkText(variationItemName, false, setVariationItemNameError);
  }, [variationItemName]);

  useEffect(() => {
    checkFileOthers(variationFile!, false, setVariationFileError);
  }, [variationFile]);

  function checkCredentials(): boolean {
    const num = checkText(variationNumber, true, setVariationNumberError);
    const amount = checkNumber(variationAmount!, true, setVariationAmountError);
    const title = checkText(variationItemName, true, setVariationItemNameError);
    const file = checkFileOthers(variationFile!, false, setVariationFileError);
    return num && amount && title && file;
  }

  // Variation INSERT Function
  const handleCreateVariation = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);
      const data = await addVariation(
        selectedValuationEditData?.id!,
        variationNumber,
        variationAmount!,
        variationItemName,
        variationFile
      );
      setLoading(false);

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getValuationEditDataByFolder(folderId));

        setLoading(false);
        setShowVariationModal(false);
        setHasVariation(true);
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Item created successfully.",
            life: 3000,
          });
        }
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating item.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleEditVariation = () => {
    setShowVariationModal(true);
    setDataState("Edit");

    if (selectedVariation) {
      setVariationNumber(selectedVariation.variation_no!);
      setVariationItemName(selectedVariation?.item_name!);
      setVariationAmount(selectedVariation.amount!);
      if (selectedVariation.path) {
        const fileUrl = selectedVariation.path;
        const fileName = selectedVariation.path.split("/").pop() || "file";
        const file = new File([fileUrl], fileName);
        setVariationFile(file);
      }
    } else {
      setVariationNumber("");
      setVariationItemName("");
      setVariationAmount(null);
      setVariationFile(null);
    }
  };

  const handleClearVariationFields = () => {
    setVariationNumber("");
    setVariationItemName("");
    setVariationAmount(null);
  };

  // Variation UPDATE function
  const handleUpdateVariation = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);
      const data = await updateVariation(
        variationNumber,
        variationAmount!,
        variationItemName,
        variationFile,
        selectedVariation?.id!
      );
      setLoading(false);

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getValuationEditDataByFolder(folderId));

        setLoading(false);
        setShowVariationModal(false);
        setHasVariation(true);
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Item update successfully.",
            life: 3000,
          });
        }
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the item.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteVariation = (): void => {
    confirmDialog({
      message: `Are you sure you want to delete this variation item?`,
      header: "Confirm the deletion",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteVariationItem(),
      dismissableMask: true,
      draggable: false,
      resizable: false,
    });
  };

  // DELETE vartion function
  const deleteVariationItem = async () => {
    const result = await deleteVarationData(selectedVariation?.id!);

    if (result.statusCode === 200) {
      dispatch(getValuationEditDataByFolder(folderId));

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Item deleted successfully.",
          life: 3000,
        });
      }
      setSelectedVariation(null);
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "Error deleting item.",
          life: 3000,
        });
      }
    }
  };

  const variationModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} variation</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseVariationModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const variationModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseVariationModal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"
          }`}
        onClick={
          dataState === "Add" ? handleCreateVariation : handleUpdateVariation
        }
        loading={loading}
        className="custom_btn primary"
      />
    </div>
  );

  const handleVariationAmountChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setVariationAmount(e.value);
    }
  };

  const handleVariationFileUpload = (file: File) => {
    setVariationFile(file);
    setVariationFileName(file.name);
  };

  const handleClearVariationFile = () => {
    setVariationFile(null);
    setVariationFileName("");
  };
  /* **************************************************************************** */

  /* ****************************** Contingencies ******************************* */
  const handleShowContingencies = () => {
    setShowContingency(true);

    setShowSection(false);
    setShowCoverpage(false);
    setShowSubSection(false);
    setShowSubSectionItem(false);
    setShowPreliminaries(false);
    setShowVariation(false);
    setShowSummary(false);
    setShowSectionItem(false);

    setToggledSection(false);
    setToggledSubSection(false);

    setShowSideBar(false);
    setPreliminaryEditable(false);
    setSectionItemEditable(false);
    setSubSectionItemEditable(false);

    goToTop();
  };

  const handleCloseContingencyModal = () => {
    setShowContingencyModal(false);
  };

  const handleAddContingency = () => {
    setShowContingencyModal(true);
    setDataState("Add");

    setSelectedContingency(null);
    handleClearContingencyFields();
  };

  // VAIDATIONS Contingencies
  useEffect(() => {
    checkNumber(contingencyAmount!, false, setContingencyAmountError);
  }, [contingencyAmount]);

  useEffect(() => {
    checkText(contingencyItemName, false, setContingencyItemNameError);
  }, [contingencyItemName]);

  function checkCredentialsContingency(): boolean {
    const amount = checkNumber(
      contingencyAmount!,
      true,
      setContingencyAmountError
    );
    const title = checkText(
      contingencyItemName,
      true,
      setContingencyItemNameError
    );

    return amount && title;
  }

  // INSERT Contingency
  const handleCreateContingency = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentialsContingency()) {
      setLoading(true);
      const data = await addContingency(
        selectedValuationEditData?.id!,
        contingencyAmount!,
        contingencyItemName
      );
      setLoading(false);
      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getValuationEditDataByFolder(folderId));

        setLoading(false);
        setShowContingencyModal(false);
        setHasContingency(true);
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Item created successfully.",
            life: 3000,
          });
        }
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating item.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleEditContingency = () => {
    setShowContingencyModal(true);
    setDataState("Edit");

    if (selectedContingency) {
      setContingencyItemName(selectedContingency?.item_name!);
      setContingencyAmount(selectedContingency?.amount!);
    } else {
      setContingencyItemName("");
      setContingencyAmount(null);
    }
  };

  const handleClearContingencyFields = () => {
    setContingencyItemName("");
    setContingencyAmount(null);
  };

  // UPDATE Contingency
  const handleUpdateContingency = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentialsContingency()) {
      setLoading(true);
      const data = await updateContingency(
        contingencyAmount!,
        contingencyItemName,
        selectedContingency?.id!
      );

      setLoading(false);
      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getValuationEditDataByFolder(folderId));

        setLoading(false);
        setShowContingencyModal(false);
        setHasContingency(true);
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Item update successfully.",
            life: 3000,
          });
        }
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the item.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteContingency = (): void => {
    confirmDialog({
      message: `Are you sure you want to delete this contingency item?`,
      header: "Confirm the deletion",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteContingencyItem(),
      dismissableMask: true,
      draggable: false,
      resizable: false,
    });
  };

  // DELETE Contingency
  const deleteContingencyItem = async () => {
    const result = await deleteContingencyData(selectedContingency?.id!);

    if (result.statusCode === 200) {
      dispatch(getValuationEditDataByFolder(folderId));

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Item deleted successfully.",
          life: 3000,
        });
      }
      setSelectedContingency(null);
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "Error deleting item.",
          life: 3000,
        });
      }
    }
  };

  const contingencyModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} contingency</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseContingencyModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const contingencyModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseContingencyModal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"
          }`}
        onClick={
          dataState === "Add"
            ? handleCreateContingency
            : handleUpdateContingency
        }
        loading={loading}
        className="custom_btn primary"
      />
    </div>
  );

  const handleContingencyAmountChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setContingencyAmount(e.value);
    }
  };
  /* **************************************************************************** */

  /* ******************************** Summary ********************************* */
  const handleShowSummary = () => {
    setShowSummary(true);

    setShowSection(false);
    setShowCoverpage(false);
    setShowSubSection(false);
    setShowSubSectionItem(false);
    setShowPreliminaries(false);
    setShowContingency(false);
    setShowVariation(false);
    setShowSectionItem(false);

    setToggledSection(false);
    setToggledSubSection(false);

    setShowSideBar(false);
    setPreliminaryEditable(false);
    setSectionItemEditable(false);
    setSubSectionItemEditable(false);

    goToTop();
  };
  /* **************************************************************************** */

  /* *********************************** Note *********************************** */
  const handleViewNote = (note: string, type: string) => {
    setShowNoteViewModal(true);
    setNoteContent(note);
    setNoteType(type);
  };

  const handleCloseNoteViewModal = () => {
    setShowNoteViewModal(false);
    setNoteContent("");
    setNoteType("");
  };

  const noteViewModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Note</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseNoteViewModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const handleCloseNoteModifyModal = () => {
    setShowNoteModifyModal(false);
  };

  const noteModifyModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Note</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseNoteModifyModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const noteModifyModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseNoteModifyModal}
      />

      <Button
        label={`${loading ? "Processing" : "Done"}`}
        onClick={
          preliminaryEditable && showPreliminaries
            ? handleSavePreliminaryNote
            : handleSaveItemNote
        }
        loading={loading}
        className="custom_btn primary"
      />
    </div>
  );
  /* **************************************************************************** */

  /* ******************************* For view document ******************************* */
  const handleViewDocument = (path: string) => {
    setDocumentPath(path);
    setShowDocumentViewModal(true);
  };

  const handleCloseDocumentViewModal = () => {
    setShowDocumentViewModal(false);
  };
  /* ********************************************************************************* */

  /* ******************************* For download document ******************************* */
  const handleShowDownload = () => {
    setShowDownloadModal(true);
  };
  /* ********************************************************************************* */

  /* **************************** Common functions ***************************** */
  const formatPrice = (value: number) => {
    return new Intl.NumberFormat("en-UK", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const formatDate = (dateString: string | undefined): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    }).format(date);
  };

  const getRowClassName = () => {
    return "project_table_row";
  };

  const goBack = () => {
    navigate(-1);
    goToTop();
  };

  const handleShowSideBar = () => {
    setShowSideBar(!showSideBar);
  };
  /* *************************************************************************** */

  /*  */
  useEffect(() => {
    if (currentSection && currentSection !== null) {
      const data = sectionData.filter(
        (section) => section.section_id === currentSection?.section_id
      );
      if (data && data?.length > 0) {
        setCurrentSection(data[0]);

        if (currentSubSection && currentSubSection !== null) {
          const dataX = data[0]?.sub_section_data?.filter(
            (subSection) =>
              subSection?.sub_section_id === currentSubSection?.sub_section_id
          );

          if (dataX && dataX?.length > 0) {
            setCurrentSubSection(dataX[0]);
          }
        }
      }
    }
  }, [sectionData]);

  return (
    <div>
      <Toast ref={toast} />

      <div className="project_toolbar">
        <Button
          icon={`bi ${showSideBar ? "bi-arrow-left" : "bi-list"}`}
          onClick={handleShowSideBar}
          className="sidebar_toggle_btn"
        />

        <div
          className={`project_tool_options ${showVariation ||
            showContingency ||
            showSectionItem ||
            showSubSectionItem ||
            showPreliminaries
            ? ""
            : "mobile_wrap"
            } tab_wrap`}
        >
          <div className="project_tool_options_sub">
            {selectedValuationEditData &&
              selectedValuationEditData?.is_fixed === 0 && (
                <React.Fragment>
                  {showSectionItem && (
                    <button
                      className={`is_btn project_tool_btn ${sectionItemEditable && "cancel_btn"
                        } p-ripple`}
                      onClick={handleToggleSectionItemEditable}
                      disabled={!showSectionItem}
                    >
                      {sectionItemEditable ? "Cancel" : "Edit"}
                      <Ripple />
                    </button>
                  )}

                  {showSubSectionItem && (
                    <button
                      className={`is_btn project_tool_btn ${subSectionItemEditable && "cancel_btn"
                        } p-ripple`}
                      onClick={handleToggleSubSectionItemEditable}
                      disabled={!showSubSectionItem}
                    >
                      {subSectionItemEditable ? "Cancel" : "Edit"}
                      <Ripple />
                    </button>
                  )}

                  {showPreliminaries && (
                    <button
                      className={`is_btn project_tool_btn ${preliminaryEditable && "cancel_btn"
                        } p-ripple`}
                      onClick={handleTogglePreliminaryEditable}
                      disabled={!showPreliminaries}
                    >
                      {preliminaryEditable ? "Cancel" : "Edit"}
                      <Ripple />
                    </button>
                  )}

                  {showVariation && (
                    <React.Fragment>
                      <button
                        className={`is_btn project_tool_btn p-ripple`}
                        onClick={handleAddVariation}
                      >
                        Add
                        <Ripple />
                      </button>

                      <button
                        className={`is_btn project_tool_btn p-ripple`}
                        onClick={handleEditVariation}
                        disabled={!hasVariation || selectedVariation === null}
                      >
                        Edit
                        {hasVariation && selectedVariation !== null && (
                          <Ripple />
                        )}
                      </button>

                      <button
                        className={`is_btn project_tool_btn p-ripple`}
                        onClick={handleDeleteVariation}
                        disabled={!hasVariation || selectedVariation === null}
                      >
                        Delete
                        {hasVariation && selectedVariation !== null && (
                          <Ripple />
                        )}
                      </button>
                    </React.Fragment>
                  )}

                  {showContingency && (
                    <React.Fragment>
                      <button
                        className={`is_btn project_tool_btn p-ripple`}
                        onClick={handleAddContingency}
                      >
                        Add
                        <Ripple />
                      </button>

                      <button
                        className={`is_btn project_tool_btn p-ripple`}
                        onClick={handleEditContingency}
                        disabled={
                          !hasContingency || selectedContingency === null
                        }
                      >
                        Edit
                        {hasContingency && selectedContingency !== null && (
                          <Ripple />
                        )}
                      </button>

                      <button
                        className={`is_btn project_tool_btn p-ripple`}
                        onClick={handleDeleteContingency}
                        disabled={
                          !hasContingency || selectedContingency === null
                        }
                      >
                        Delete
                        {hasContingency && selectedContingency !== null && (
                          <Ripple />
                        )}
                      </button>
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}

            {(sharedBy === null &&
              selectedValuationEditData &&
              selectedValuationEditData?.is_fixed === 0) ? (
              <button
                className={`is_btn project_tool_btn p-ripple`}
                onClick={handleFixValuationEdit}
              >
                Fix valuation
                <Ripple />
              </button>
            ) : (selectedValuationEditData &&
              selectedValuationEditData?.is_fixed === 1) ? (<label className="fixed_label"> Fixed</label>) : ('')}
          </div>

          <div className="project_tool_options_sub">
            <button
              className={`is_btn project_tool_btn p-ripple`}
              onClick={handleShowDownload}
            >
              Download
              <Ripple />
            </button>
            <button
              className={`is_btn project_tool_btn p-ripple`}
              onClick={goBack}
            >
              Back
              <Ripple />
            </button>
          </div>
        </div>
      </div>

      <div className={`project_sidebar ${showSideBar ? "show" : ""}`}>
        <ul className="section_list">
          {/* Cover page */}
          <li className="section_list_item">
            <div className={`section_link_grp ${showCoverPage && "active"}`}>
              <i className="bi bi-caret-right-fill section_link_icon"></i>
              <button
                className="section_link is_btn"
                onClick={handleShowCoverPage}
              >
                <span>Cover page</span>
              </button>
            </div>
          </li>

          {/* Sections */}
          <li className="section_list_item">
            <div
              className={`section_link_grp ${showSection && "active"} ${toggledSection && sectionData?.length > 0 && "has_child"
                } `}
            >
              <i className="bi bi-caret-right-fill section_link_icon"></i>
              <button
                className="section_link is_btn"
                onClick={handleShowSection}
              >
                <span>Contents</span>
              </button>
            </div>

            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{
                height: toggledSection ? "auto" : 0,
                opacity: toggledSection ? 1 : 0,
              }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              style={{ overflow: "hidden" }}
            >
              {sectionData?.length > 0 && (
                <ul className="section_sub_list">
                  {sectionData?.map((section) => (
                    <li
                      key={section.section_id}
                      className="section_sub_list_item"
                    >
                      <div
                        className={`section_link_grp ${showSubSection &&
                          section.section_id === currentSection?.section_id &&
                          "active"
                          } ${toggledSubSection &&
                          section?.sub_section_data?.length! > 0 &&
                          "has_child"
                          } `}
                      >
                        <i className="bi bi-caret-right section_link_icon"></i>
                        <button
                          className="section_link is_btn"
                          onClick={() => handleShowSubSection(section)}
                        >
                          <span>Section {section.section_no}</span>
                        </button>
                      </div>

                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{
                          height: toggledSubSection ? "auto" : 0,
                          opacity: toggledSubSection ? 1 : 0,
                        }}
                        transition={{ duration: 0.5, ease: "easeInOut" }}
                        style={{ overflow: "hidden" }}
                      >
                        {section?.sub_section_data?.length! > 0 && (
                          <ul className="section_sub_list_sub">
                            {section.sub_section_data?.map((sub_section) => (
                              <li className="section_sub_list_item_sub">
                                <div
                                  className={`section_link_grp ${showSubSectionItem &&
                                    sub_section.sub_section_id ===
                                    currentSubSection?.sub_section_id &&
                                    "active"
                                    } `}
                                >
                                  <small>{sub_section.sub_section_no}</small>
                                  <button
                                    className="section_link is_btn"
                                    onClick={() =>
                                      handleShowSubSectionItem(sub_section)
                                    }
                                  >
                                    <span>{sub_section.sub_section_name}</span>
                                  </button>
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </motion.div>
                    </li>
                  ))}
                </ul>
              )}
            </motion.div>
          </li>

          {/* Preliminaries */}
          <li className="section_list_item">
            <div
              className={`section_link_grp ${showPreliminaries && "active"}`}
            >
              <i className="bi bi-caret-right-fill section_link_icon"></i>
              <button
                className="section_link is_btn"
                onClick={handleShowPreliminaries}
              >
                <span>Preliminaries</span>
              </button>
            </div>
          </li>

          {/* Variation */}
          <li className="section_list_item">
            <div className={`section_link_grp ${showVariation && "active"}`}>
              <i className="bi bi-caret-right-fill section_link_icon"></i>
              <button
                className="section_link is_btn"
                onClick={handleShowVariation}
              >
                <span>Variation</span>
              </button>
            </div>
          </li>

          {/* Contingencies */}
          <li className="section_list_item">
            <div className={`section_link_grp ${showContingency && "active"}`}>
              <i className="bi bi-caret-right-fill section_link_icon"></i>
              <button
                className="section_link is_btn"
                onClick={handleShowContingencies}
              >
                <span>Contingencies</span>
              </button>
            </div>
          </li>

          {/* Summary */}
          <li className="section_list_item">
            <div className={`section_link_grp ${showSummary && "active"}`}>
              <i className="bi bi-caret-right-fill section_link_icon"></i>
              <button
                className="section_link is_btn"
                onClick={handleShowSummary}
              >
                <span>Summary</span>
              </button>
            </div>
          </li>
        </ul>
      </div>

      <div
        className={`layout_backdrop ${showSideBar ? "show" : ""}`}
        onClick={handleShowSideBar}
      ></div>

      <div
        className={`project_main_content ${showSideBar ? "has_sidebar" : ""}`}
      >
        {((valuationEditData && valuationEditData?.length > 0) || (sharedBy === null && valuationEdit && (valuationEdit?.valuation_edit_data?.filter((e) => e.is_fixed === 0)?.length === 0))) && (
          <div className="valution_edit_header_area">
            {valuationEditData && valuationEditData?.length > 0 && (
              <ul className="valuation_tab_area">
                {valuationEditData?.map((valuation) => (
                  <li
                    key={valuation.id}
                    className={`valuation_list_item ${selectedValuationEditData?.id === valuation.id
                      ? "active"
                      : ""
                      }`}
                  >
                    <button
                      className={`is_btn valuation_button p-ripple`}
                      onClick={() => handleChangeValuationEdit(valuation)}
                    >
                      Valuation&nbsp;{valuation?.valuation_edit_no}
                      <Ripple />
                    </button>
                  </li>
                ))}
              </ul>
            )}

            {sharedBy === null && valuationEdit && (valuationEdit?.valuation_edit_data?.filter((e) => e.is_fixed === 0)?.length === 0) && (
              <button
                className="add_data_link_btn p-ripple"
                onClick={handleAddValuation}
              >
                <i className="bi bi-plus-circle"></i>
                <span>Add Valuation</span>
                <Ripple />
              </button>
            )}
          </div>
        )}

        {/* Cover page */}
        {showCoverPage && (
          <Fade duration={300} triggerOnce>
            <article className="main_section_area d-flex">
              {coverPageData && coverPageData !== null ? (
                <div className="cover_page_area">
                  <h2>{coverPageData?.title}</h2>
                  <h6>{coverPageData?.text}</h6>
                  <h5>At</h5>
                  <h5>

                    {address}

                  </h5>
                  <br />
                  <h5>
                    By <br />
                    {(coverPageData?.comapny?.company_name !== null) ? coverPageData?.comapny?.company_name : coverPageData?.comapny?.first_name}
                  </h5>
                </div>
              ) : (
                <div className="no_content_added_area">
                  <img
                    src="/assets/images/no_data/no_data_img.png"
                    alt="No data!"
                  />
                  <p>No cover page found!</p>
                </div>
              )}
            </article>
          </Fade>
        )}

        {/* Section */}
        {showSection && (
          <Fade duration={300} triggerOnce>
            <article className="main_section_area">
              <div className="main_section_header">
                <h6>Contents</h6>
              </div>
              {hasSection && sectionData?.length > 0 ? (
                <DataTable
                  value={sectionData}
                  size="small"
                  tableStyle={{ minWidth: "50rem" }}
                  className="page_table project_table view_only p-0 p-sm-2"
                  tableClassName="mb-1"
                  rowClassName={getRowClassName}
                  scrollable
                  dataKey="section_id"
                  scrollHeight={"75vh"}
                  emptyMessage="No data found"
                  footerColumnGroup={
                    <ColumnGroup>
                      <Row>
                        <Column
                          footer="Sub total:"
                          colSpan={2}
                          className="table_column text_no_wrap text-center"
                        />

                        <Column
                          footer={`${currencySymbol} ${formatPrice(
                            calculateSectionTotal(sectionData)
                          )}`}
                          className="table_column text_no_wrap text-end pe-sm-3"
                        />
                      </Row>
                    </ColumnGroup>
                  }
                >
                  <Column
                    header="Section no"
                    alignHeader={"center"}
                    body={(rowData: Section) => (
                      <span className="flex_center">
                        {rowData.section_no ? rowData.section_no : "--"}
                      </span>
                    )}
                    style={{ width: "15%" }}
                    className="table_column"
                  ></Column>
                  <Column
                    header="Content"
                    body={(rowData: Section) => (
                      <span>
                        {rowData.section_name ? rowData.section_name : "--"}
                      </span>
                    )}
                    style={{ width: "65%" }}
                    className="table_column"
                  ></Column>
                  <Column
                    header="Price"
                    alignHeader={"right"}
                    body={(rowData: Section) => (
                      <span className="flex-end text-end text_no_wrap price_text">
                        {rowData.section_amount !== null
                          ? currencySymbol +
                          " " +
                          formatPrice(rowData.section_amount!)
                          : "--"}
                      </span>
                    )}
                    style={{ width: "20%" }}
                    className="table_column text-end"
                  ></Column>
                </DataTable>
              ) : (
                <div className="no_content_added_area">
                  <img
                    src="/assets/images/no_data/no_data_img.png"
                    alt="No data!"
                  />
                  <p>No section(s) found!</p>
                </div>
              )}
            </article>
          </Fade>
        )}

        {/* Sub section & Section item */}
        {showSubSection && (
          <Fade duration={300} triggerOnce>
            <article className="main_section_area">
              {currentSection && (
                <div className="main_section_header">
                  <h6>
                    {currentSection?.section_no}.&nbsp;&nbsp;
                    {currentSection?.section_name}
                  </h6>
                </div>
              )}

              {/* Sub section */}
              {hasSubSection && (
                <Fade duration={300} triggerOnce>
                  {currentSection?.sub_section_data && (
                    <DataTable
                      value={currentSection?.sub_section_data}
                      size="small"
                      tableStyle={{ minWidth: "50rem" }}
                      className="page_table project_table view_only p-0 p-sm-2"
                      rowHover
                      tableClassName="mb-1"
                      rowClassName={getRowClassName}
                      dataKey="sub_section_id"
                      scrollable
                      scrollHeight={"75vh"}
                      emptyMessage="No data found"
                      footerColumnGroup={
                        <ColumnGroup>
                          <Row>
                            <Column
                              footer="Sub total:"
                              colSpan={2}
                              className="table_column text_no_wrap text-center"
                            />

                            <Column
                              footer={`${currencySymbol} ${formatPrice(
                                calculateSubSectionTotal(
                                  currentSection?.sub_section_data
                                )
                              )}`}
                              className="table_column text_no_wrap text-end pe-sm-3"
                            />
                          </Row>
                        </ColumnGroup>
                      }
                    >
                      <Column
                        header="Sub section no."
                        alignHeader={"center"}
                        body={(rowData: SubSection) => (
                          <span className="flex_center">
                            {rowData.sub_section_no
                              ? rowData.sub_section_no
                              : "--"}
                          </span>
                        )}
                        style={{ width: "15%" }}
                        className="table_column"
                      ></Column>

                      <Column
                        header="Sub section name"
                        body={(rowData: SubSection) => (
                          <span>
                            {rowData.sub_section_name
                              ? rowData.sub_section_name
                              : "--"}
                          </span>
                        )}
                        style={{ width: "65%" }}
                        className="table_column"
                      ></Column>

                      <Column
                        header="Price"
                        alignHeader={"right"}
                        body={(rowData: SubSection) => (
                          <span className="flex-end text-end text_no_wrap price_text">
                            {rowData.sub_section_amount !== null
                              ? currencySymbol +
                              " " +
                              formatPrice(rowData.sub_section_amount!)
                              : "--"}
                          </span>
                        )}
                        style={{ width: "20%" }}
                        className="table_column text-end"
                      ></Column>
                    </DataTable>
                  )}
                </Fade>
              )}

              {/* Section Item */}
              {hasSectionItem && (
                <Fade duration={300} triggerOnce>
                  {currentSection?.section_item_data && (
                    <DataTable
                      value={currentSection?.section_item_data}
                      size="small"
                      tableStyle={{ minWidth: "50rem" }}
                      className="page_table project_table row_group_table p-0 p-sm-2"
                      rowHover
                      tableClassName="mb-1"
                      rowClassName={getRowClassName}
                      dataKey="item_id"
                      metaKeySelection={false}
                      scrollable
                      editMode="cell"
                      scrollHeight={"75vh"}
                      emptyMessage="No data found"
                      headerColumnGroup={ItemTableHeaderGroup}
                      footerColumnGroup={
                        <ColumnGroup>
                          <Row>
                            <Column
                              footer="Sub total:"
                              colSpan={4}
                              className="table_column text_no_wrap text-center"
                            />

                            <Column
                              footer={`${currencySymbol} ${formatPrice(
                                calculateSumSectionItem(
                                  currentSection?.section_item_data,
                                  "architect"
                                )
                              )}`}
                              className="table_column text_no_wrap text-end"
                            />

                            <Column className="table_column" />

                            <Column
                              footer={`${currencySymbol} ${formatPrice(
                                calculateSumSectionItem(
                                  currentSection?.section_item_data,
                                  "builder"
                                )
                              )}`}
                              className="table_column text_no_wrap text-end"
                            />

                            <Column className="table_column" colSpan={3} />
                          </Row>
                        </ColumnGroup>
                      }
                    >
                      <Column
                        field="item_no"
                        body={(rowData: SectionItem) => (
                          <span className="flex_center">
                            {rowData.item_no ? rowData.item_no : "--"}
                          </span>
                        )}
                        className="table_column text-center"
                      ></Column>

                      <Column
                        field="item_name"
                        body={(rowData: SectionItem) => (
                          <span>
                            {rowData.item_name ? rowData.item_name : "--"}
                          </span>
                        )}
                        className="table_column item_name_column name_text"
                      ></Column>

                      <Column
                        field="item_amount_total"
                        body={(rowData: SectionItem) => (
                          <span className="flex-end text_no_wrap">
                            {rowData.item_amount_total != null
                              ? currencySymbol +
                              " " +
                              formatPrice(rowData.item_amount_total)
                              : "--"}
                          </span>
                        )}
                        className="table_column text-end column_editable"
                      ></Column>

                      <Column
                        field="architect_data.percentage"
                        body={(rowData: SectionItem) => (
                          <span className="flex_center text_no_wrap">
                            {rowData.architect_data?.percentage != null
                              ? rowData.architect_data?.percentage + "%"
                              : "--"}
                          </span>
                        )}
                        className={`table_column text-center percentage_column ${isArchitectEditable && "column_as_input"
                          } ${sectionItemEditable &&
                          isArchitectEditable &&
                          " edit_mode editable"
                          }`}
                        editor={
                          sectionItemEditable && isArchitectEditable
                            ? (options) => itemEditor(options)
                            : undefined
                        }
                      ></Column>

                      <Column
                        field="architect_data.value"
                        body={(rowData: SectionItem) => (
                          <span className="flex_end text_no_wrap">
                            {rowData.architect_data?.value
                              ? currencySymbol +
                              " " +
                              formatPrice(rowData.architect_data?.value)
                              : "--"}
                          </span>
                        )}
                        className="table_column text-end"
                      ></Column>

                      <Column
                        field="builder_data.percentage"
                        body={(rowData: SectionItem) => (
                          <span className="flex_center text_no_wrap">
                            {rowData.builder_data?.percentage
                              ? rowData.builder_data?.percentage + "%"
                              : "--"}
                          </span>
                        )}
                        className={`table_column text-center percentage_column ${isBuilderEditable && "column_as_input"
                          } ${sectionItemEditable &&
                          isBuilderEditable &&
                          " edit_mode editable"
                          }`}
                        editor={
                          sectionItemEditable && isBuilderEditable
                            ? (options) => itemEditor(options)
                            : undefined
                        }
                      ></Column>

                      <Column
                        field="builder_data.value"
                        body={(rowData: SectionItem) => (
                          <span className="flex_end text_no_wrap">
                            {rowData.builder_data?.value
                              ? currencySymbol +
                              " " +
                              formatPrice(rowData.builder_data?.value)
                              : "--"}
                          </span>
                        )}
                        className="table_column text-end"
                      ></Column>

                      <Column
                        field="architect_data.note"
                        body={(rowData: SectionItem) => (
                          <span
                            className={`flex_center text-center cursor_pointer ${!isArchitectEditable &&
                              !rowData?.architect_data?.note &&
                              "pointer-event-none"
                              }`}
                            onClick={() =>
                              sectionItemEditable && isArchitectEditable
                                ? handleModifySectionItemNote(
                                  rowData,
                                  "Architect"
                                )
                                : handleViewNote(
                                  rowData?.architect_data?.note!,
                                  "Architect"
                                )
                            }
                          >
                            {rowData.architect_data?.note
                              ? rowData.architect_data?.note
                              : "--"}
                          </span>
                        )}
                        style={{ width: "12%" }}
                        className={`table_column text-center note_column name_text ${isArchitectEditable && "column_as_input"
                          } ${sectionItemEditable &&
                          isArchitectEditable &&
                          " edit_mode editable"
                          }`}
                      ></Column>

                      <Column
                        field="builder_data.note"
                        body={(rowData: SectionItem) => (
                          <span
                            className={`flex_center text-center cursor_pointer ${!isBuilderEditable &&
                              !rowData?.builder_data?.note &&
                              "pointer-event-none"
                              }`}
                            onClick={() =>
                              sectionItemEditable && isBuilderEditable
                                ? handleModifySectionItemNote(
                                  rowData,
                                  "Builder"
                                )
                                : handleViewNote(
                                  rowData?.builder_data?.note!,
                                  "Builder"
                                )
                            }
                          >
                            {rowData.builder_data?.note
                              ? rowData.builder_data?.note
                              : "--"}
                          </span>
                        )}
                        style={{ width: "12%" }}
                        className={`table_column text-center note_column name_text ${isBuilderEditable && "column_as_input"
                          } ${sectionItemEditable &&
                          isBuilderEditable &&
                          " edit_mode editable"
                          }`}
                      ></Column>

                      <Column
                        field="client_note"
                        body={(rowData: SectionItem) => (
                          <span
                            className={`flex_center text-center cursor_pointer ${!isClientEditable &&
                              !rowData?.client_note &&
                              "pointer-event-none"
                              }`}
                            onClick={() =>
                              sectionItemEditable && isClientEditable
                                ? handleModifySectionItemNote(rowData, "Client")
                                : handleViewNote(
                                  rowData?.client_note!,
                                  "Client"
                                )
                            }
                          >
                            {rowData.client_note ? rowData.client_note : "--"}
                          </span>
                        )}
                        style={{ width: "12%" }}
                        className={`table_column text-center note_column name_text ${isClientEditable && "column_as_input"
                          } ${sectionItemEditable &&
                          isClientEditable &&
                          " edit_mode editable"
                          }`}
                      ></Column>
                    </DataTable>
                  )}
                </Fade>
              )}

              {!hasSubSection && !hasSectionItem && (
                <Fade duration={300} triggerOnce>
                  <div className="no_content_added_area">
                    <img
                      src="/assets/images/no_data/no_data_img.png"
                      alt="No data!"
                    />
                    <p>No data found!</p>
                  </div>
                </Fade>
              )}
            </article>
          </Fade>
        )}

        {/* Sub section item */}
        {showSubSectionItem && (
          <Fade duration={300} triggerOnce>
            <article className="main_section_area">
              {currentSubSection && (
                <div className="main_section_header">
                  <h6>
                    {currentSubSection?.sub_section_no}.&nbsp;&nbsp;
                    {currentSubSection?.sub_section_name}
                  </h6>
                </div>
              )}

              {hasSubSectionItem ? (
                <React.Fragment>
                  {currentSubSection?.sub_section_item_data && (
                    <DataTable
                      value={currentSubSection?.sub_section_item_data}
                      size="small"
                      tableStyle={{ minWidth: "50rem" }}
                      className="page_table project_table row_group_table p-0 p-sm-2"
                      rowHover
                      tableClassName="mb-1"
                      rowClassName={getRowClassName}
                      dataKey="item_id"
                      metaKeySelection={false}
                      scrollable
                      editMode="cell"
                      scrollHeight={"75vh"}
                      emptyMessage="No data found"
                      headerColumnGroup={ItemTableHeaderGroup}
                      footerColumnGroup={
                        <ColumnGroup>
                          <Row>
                            <Column
                              footer="Sub total:"
                              colSpan={4}
                              className="table_column text_no_wrap text-center"
                            />

                            <Column
                              footer={`${currencySymbol} ${formatPrice(
                                calculateSumSubSectionItem(
                                  currentSubSection?.sub_section_item_data,
                                  "architect"
                                )
                              )}`}
                              className="table_column text_no_wrap text-end"
                            />

                            <Column className="table_column" />

                            <Column
                              footer={`${currencySymbol} ${formatPrice(
                                calculateSumSubSectionItem(
                                  currentSubSection?.sub_section_item_data,
                                  "builder"
                                )
                              )}`}
                              className="table_column text_no_wrap text-end"
                            />

                            <Column className="table_column" colSpan={3} />
                          </Row>
                        </ColumnGroup>
                      }
                    >
                      <Column
                        field="item_no"
                        body={(rowData: SubSectionItem) => (
                          <span className="flex_center">
                            {rowData.item_no ? rowData.item_no : "--"}
                          </span>
                        )}
                        className="table_column text-center"
                      ></Column>

                      <Column
                        field="item_name"
                        body={(rowData: SubSectionItem) => (
                          <span>
                            {rowData.item_name ? rowData.item_name : "--"}
                          </span>
                        )}
                        className="table_column item_name_column name_text"
                      ></Column>

                      <Column
                        field="item_amount_total"
                        body={(rowData: SubSectionItem) => (
                          <span className="flex-end text_no_wrap">
                            {rowData.item_amount_total != null
                              ? currencySymbol +
                              " " +
                              formatPrice(rowData.item_amount_total)
                              : "--"}
                          </span>
                        )}
                        className="table_column text-end column_editable"
                      ></Column>

                      <Column
                        field="architect_data.percentage"
                        body={(rowData: SubSectionItem) => (
                          <span className="flex_center text_no_wrap">
                            {rowData.architect_data?.percentage != null
                              ? rowData.architect_data?.percentage + "%"
                              : "--"}
                          </span>
                        )}
                        className={`table_column text-center percentage_column ${isArchitectEditable && "column_as_input"
                          } ${subSectionItemEditable &&
                          isArchitectEditable &&
                          " edit_mode editable"
                          }`}
                        editor={
                          subSectionItemEditable && isArchitectEditable
                            ? (options) => itemEditor(options)
                            : undefined
                        }
                      ></Column>

                      <Column
                        field="architect_data.value"
                        body={(rowData: SubSectionItem) => (
                          <span className="flex_end text_no_wrap">
                            {rowData.architect_data?.value
                              ? currencySymbol +
                              " " +
                              formatPrice(rowData.architect_data?.value)
                              : "--"}
                          </span>
                        )}
                        className="table_column text-end"
                      ></Column>

                      <Column
                        field="builder_data.percentage"
                        body={(rowData: SubSectionItem) => (
                          <span className="flex_center text_no_wrap">
                            {rowData.builder_data?.percentage
                              ? rowData.builder_data?.percentage + "%"
                              : "--"}
                          </span>
                        )}
                        className={`table_column text-center percentage_column ${isBuilderEditable && "column_as_input"
                          } ${subSectionItemEditable &&
                          isBuilderEditable &&
                          " edit_mode editable"
                          }`}
                        editor={
                          subSectionItemEditable && isBuilderEditable
                            ? (options) => itemEditor(options)
                            : undefined
                        }
                      ></Column>

                      <Column
                        field="builder_data.value"
                        body={(rowData: SubSectionItem) => (
                          <span className="flex_end text_no_wrap">
                            {rowData.builder_data?.value
                              ? currencySymbol +
                              " " +
                              formatPrice(rowData.builder_data?.value)
                              : "--"}
                          </span>
                        )}
                        className="table_column text-end"
                      ></Column>

                      <Column
                        field="architect_data.note"
                        body={(rowData: SubSectionItem) => (
                          <span
                            className={`flex_center text-center cursor_pointer ${!isArchitectEditable &&
                              !rowData?.architect_data?.note &&
                              "pointer-event-none"
                              }`}
                            onClick={() =>
                              subSectionItemEditable && isArchitectEditable
                                ? handleModifySubSectionItemNote(
                                  rowData,
                                  "Architect"
                                )
                                : handleViewNote(
                                  rowData?.architect_data?.note!,
                                  "Architect"
                                )
                            }
                          >
                            {rowData.architect_data?.note
                              ? rowData.architect_data?.note
                              : "--"}
                          </span>
                        )}
                        style={{ width: "12%" }}
                        className={`table_column text-center note_column name_text ${isArchitectEditable && "column_as_input"
                          } ${subSectionItemEditable &&
                          isArchitectEditable &&
                          " edit_mode editable"
                          }`}
                      ></Column>

                      <Column
                        field="builder_data.note"
                        body={(rowData: SubSectionItem) => (
                          <span
                            className={`flex_center text-center cursor_pointer ${!isBuilderEditable &&
                              !rowData?.builder_data?.note &&
                              "pointer-event-none"
                              }`}
                            onClick={() =>
                              subSectionItemEditable && isBuilderEditable
                                ? handleModifySubSectionItemNote(
                                  rowData,
                                  "Builder"
                                )
                                : handleViewNote(
                                  rowData?.builder_data?.note!,
                                  "Builder"
                                )
                            }
                          >
                            {rowData.builder_data?.note
                              ? rowData.builder_data?.note
                              : "--"}
                          </span>
                        )}
                        style={{ width: "12%" }}
                        className={`table_column text-center note_column name_text ${isBuilderEditable && "column_as_input"
                          } ${subSectionItemEditable &&
                          isBuilderEditable &&
                          " edit_mode editable"
                          }`}
                      ></Column>

                      <Column
                        field="client_note"
                        body={(rowData: SubSectionItem) => (
                          <span
                            className={`flex_center text-center cursor_pointer ${!isClientEditable &&
                              !rowData?.client_note &&
                              "pointer-event-none"
                              }`}
                            onClick={() =>
                              subSectionItemEditable && isClientEditable
                                ? handleModifySubSectionItemNote(
                                  rowData,
                                  "Client"
                                )
                                : handleViewNote(
                                  rowData?.client_note!,
                                  "Client"
                                )
                            }
                          >
                            {rowData.client_note ? rowData.client_note : "--"}
                          </span>
                        )}
                        style={{ width: "12%" }}
                        className={`table_column text-center note_column name_text ${isClientEditable && "column_as_input"
                          } ${subSectionItemEditable &&
                          isClientEditable &&
                          " edit_mode editable"
                          }`}
                      ></Column>
                    </DataTable>
                  )}
                </React.Fragment>
              ) : (
                <div className="no_content_added_area">
                  <img
                    src="/assets/images/no_data/no_data_img.png"
                    alt="No data!"
                  />
                  <p>No item(s) found!</p>
                </div>
              )}
            </article>
          </Fade>
        )}

        {/* Preliminaries */}
        {showPreliminaries && (
          <Fade duration={300} triggerOnce>
            <article className="main_section_area">
              {preliminariesData && preliminariesData?.length > 0 ? (
                <DataTable
                  value={preliminariesData}
                  size="small"
                  tableStyle={{ minWidth: "50rem" }}
                  className="page_table project_table row_group_table p-0 p-sm-2"
                  rowHover
                  tableClassName="mb-1"
                  rowClassName={getRowClassName}
                  dataKey="priliminiery_id"
                  metaKeySelection={false}
                  scrollable
                  editMode="cell"
                  scrollHeight={"75vh"}
                  emptyMessage="No data found"
                  headerColumnGroup={PreliminariesTableHeaderGroup}
                  footerColumnGroup={
                    <ColumnGroup>
                      <Row>
                        <Column
                          footer="Sub total:"
                          colSpan={4}
                          className="table_column text_no_wrap text-center"
                        />

                        <Column
                          footer={`${currencySymbol} ${formatPrice(
                            calculateSumPreliminary(
                              preliminariesData,
                              "architect"
                            )
                          )}`}
                          className="table_column text_no_wrap text-end"
                        />

                        <Column className="table_column" />

                        <Column
                          footer={`${currencySymbol} ${formatPrice(
                            calculateSumPreliminary(
                              preliminariesData,
                              "builder"
                            )
                          )}`}
                          className="table_column text_no_wrap text-end"
                        />

                        <Column className="table_column" colSpan={3} />
                      </Row>
                    </ColumnGroup>
                  }
                >
                  <Column
                    field="ref_number"
                    body={(rowData: Preliminary) => (
                      <span className="flex_center">
                        {rowData.ref_number ? rowData.ref_number : "--"}
                      </span>
                    )}
                    className="table_column text-center"
                  ></Column>

                  <Column
                    field="item_name"
                    body={(rowData: Preliminary) => (
                      <span>
                        {rowData.item_name ? rowData.item_name : "--"}
                      </span>
                    )}
                    className="table_column item_name_column name_text"
                  ></Column>

                  <Column
                    field="priliminiery_amount_total"
                    body={(rowData: Preliminary) => (
                      <span className="flex-end text_no_wrap">
                        {rowData.priliminiery_amount_total != null
                          ? currencySymbol +
                          " " +
                          formatPrice(rowData.priliminiery_amount_total)
                          : "--"}
                      </span>
                    )}
                    className="table_column text-end column_editable"
                  ></Column>

                  <Column
                    field="architect_data.percentage"
                    body={(rowData: Preliminary) => (
                      <span className="flex_center text_no_wrap">
                        {rowData.architect_data?.percentage != null
                          ? rowData.architect_data?.percentage + "%"
                          : "--"}
                      </span>
                    )}
                    className={`table_column text-center percentage_column ${isArchitectEditable && "column_as_input"
                      } ${preliminaryEditable &&
                      isArchitectEditable &&
                      " edit_mode editable"
                      }`}
                    editor={
                      preliminaryEditable && isArchitectEditable
                        ? (options) => preliminaryEditor(options)
                        : undefined
                    }
                  ></Column>

                  <Column
                    field="architect_data.value"
                    body={(rowData: Preliminary) => (
                      <span className="flex_end text_no_wrap">
                        {rowData.architect_data?.value
                          ? currencySymbol +
                          " " +
                          formatPrice(rowData.architect_data?.value)
                          : "--"}
                      </span>
                    )}
                    className="table_column text-end"
                  ></Column>

                  <Column
                    field="builder_data.percentage"
                    body={(rowData: Preliminary) => (
                      <span className="flex_center text_no_wrap">
                        {rowData.builder_data?.percentage
                          ? rowData.builder_data?.percentage + "%"
                          : "--"}
                      </span>
                    )}
                    className={`table_column text-center percentage_column ${isBuilderEditable && "column_as_input"
                      } ${preliminaryEditable &&
                      isBuilderEditable &&
                      " edit_mode editable"
                      }`}
                    editor={
                      preliminaryEditable && isBuilderEditable
                        ? (options) => preliminaryEditor(options)
                        : undefined
                    }
                  ></Column>

                  <Column
                    field="builder_data.value"
                    body={(rowData: Preliminary) => (
                      <span className="flex_end text_no_wrap">
                        {rowData.builder_data?.value
                          ? currencySymbol +
                          " " +
                          formatPrice(rowData.builder_data?.value)
                          : "--"}
                      </span>
                    )}
                    className="table_column text-end"
                  ></Column>

                  <Column
                    field="architect_data.note"
                    body={(rowData: Preliminary) => (
                      <span
                        className={`flex_center text-center cursor_pointer ${!isArchitectEditable &&
                          !rowData?.architect_data?.note &&
                          "pointer-event-none"
                          }`}
                        onClick={() =>
                          preliminaryEditable && isArchitectEditable
                            ? handleModifyPreliminaryNote(rowData, "Architect")
                            : handleViewNote(
                              rowData?.architect_data?.note!,
                              "Architect"
                            )
                        }
                      >
                        {rowData.architect_data?.note
                          ? rowData.architect_data?.note
                          : "--"}
                      </span>
                    )}
                    style={{ width: "12%" }}
                    className={`table_column text-center note_column name_text ${isArchitectEditable && "column_as_input"
                      } ${preliminaryEditable &&
                      isArchitectEditable &&
                      " edit_mode editable"
                      }`}
                  ></Column>

                  <Column
                    field="builder_data.note"
                    body={(rowData: Preliminary) => (
                      <span
                        className={`flex_center text-center cursor_pointer ${!isBuilderEditable &&
                          !rowData?.builder_data?.note &&
                          "pointer-event-none"
                          }`}
                        onClick={() =>
                          preliminaryEditable && isBuilderEditable
                            ? handleModifyPreliminaryNote(rowData, "Builder")
                            : handleViewNote(
                              rowData?.builder_data?.note!,
                              "Builder"
                            )
                        }
                      >
                        {rowData.builder_data?.note
                          ? rowData.builder_data?.note
                          : "--"}
                      </span>
                    )}
                    style={{ width: "12%" }}
                    className={`table_column text-center note_column name_text ${isBuilderEditable && "column_as_input"
                      } ${preliminaryEditable &&
                      isBuilderEditable &&
                      " edit_mode editable"
                      }`}
                  ></Column>

                  <Column
                    field="client_note"
                    body={(rowData: Preliminary) => (
                      <span
                        className={`flex_center text-center cursor_pointer ${!isClientEditable &&
                          !rowData?.client_note &&
                          "pointer-event-none"
                          }`}
                        onClick={() =>
                          preliminaryEditable && isClientEditable
                            ? handleModifyPreliminaryNote(rowData, "Client")
                            : handleViewNote(rowData?.client_note!, "Client")
                        }
                      >
                        {rowData.client_note ? rowData.client_note : "--"}
                      </span>
                    )}
                    style={{ width: "12%" }}
                    className={`table_column text-center note_column name_text ${isClientEditable && "column_as_input"
                      } ${preliminaryEditable &&
                      isClientEditable &&
                      " edit_mode editable"
                      }`}
                  ></Column>
                </DataTable>
              ) : (
                <div className="no_content_added_area">
                  <img
                    src="/assets/images/no_data/no_data_img.png"
                    alt="No data!"
                  />
                  <p>No preliminaries data found!</p>
                </div>
              )}
            </article>
          </Fade>
        )}

        {/* Variation */}
        {showVariation && (
          <Fade duration={300} triggerOnce>
            <article className="main_section_area">
              <div className="main_section_header">
                <h6>Variation</h6>
              </div>
              {variationData?.data && variationData?.data?.length > 0 ? (
                <DataTable
                  value={variationData?.data as DataForVariation[]}
                  size="small"
                  tableStyle={{ minWidth: "50rem" }}
                  className="page_table project_table p-0 p-sm-2"
                  rowHover
                  tableClassName="mb-1"
                  rowClassName={getRowClassName}
                  selectionMode="single"
                  metaKeySelection={false}
                  selection={selectedVariation}
                  onSelectionChange={(e) => setSelectedVariation(e.value)}
                  dataKey="id"
                  scrollable
                  scrollHeight={"75vh"}
                  emptyMessage="No data found"
                  footerColumnGroup={
                    <ColumnGroup>
                      <Row>
                        <Column
                          footer="Sub total:"
                          colSpan={2}
                          className="table_column text_no_wrap text-center"
                        />
                        <Column
                          footer={`${currencySymbol} ${formatPrice(
                            variationData?.variation_total!
                          )}`}
                          className="table_column text_no_wrap text-end"
                        />
                        <Column className="table_column" />
                      </Row>
                    </ColumnGroup>
                  }
                >
                  <Column
                    header="Variation no."
                    alignHeader={"center"}
                    body={(rowData: DataForVariation) => (
                      <span className="flex_center">
                        {rowData?.variation_no ? rowData.variation_no : "--"}
                      </span>
                    )}
                    style={{ width: "15%" }}
                    className="table_column"
                  ></Column>

                  <Column
                    header="Item name"
                    body={(rowData: DataForVariation) => (
                      <span>
                        {rowData?.item_name ? rowData.item_name : "--"}
                      </span>
                    )}
                    style={{ width: "45%" }}
                    className="table_column name_text"
                  ></Column>

                  <Column
                    header="Amount"
                    alignHeader={"right"}
                    body={(rowData: DataForVariation) => (
                      <span className="flex-end text-end text_no_wrap">
                        {rowData?.amount
                          ? currencySymbol + " " + formatPrice(rowData.amount)
                          : "--"}
                      </span>
                    )}
                    style={{ width: "20%" }}
                    className="table_column text-end"
                  ></Column>

                  <Column
                    header="Attached doc."
                    alignHeader={"center"}
                    style={{ width: "20%" }}
                    body={(rowData: DataForVariation) => {
                      return (
                        <div className="table_document_column">
                          {rowData?.path !== null ? (
                            <button
                              className="doc_view_btn p-ripple"
                              onClick={() => handleViewDocument(rowData?.path!)}
                            >
                              <Ripple />
                              <i className="bi bi-file-earmark-pdf"></i>
                            </button>
                          ) : (
                            <span>--</span>
                          )}
                        </div>
                      );
                    }}
                    className="table_column text-center"
                  ></Column>
                </DataTable>
              ) : (
                <div className="no_content_added_area">
                  <img
                    src="/assets/images/no_data/no_data_img.png"
                    alt="No data!"
                  />
                  <p>
                    No variation item(s) added, to add the variation click on
                    add button.
                  </p>
                </div>
              )}
            </article>
          </Fade>
        )}

        {/* Contingency */}
        {showContingency && (
          <Fade duration={300} triggerOnce>
            <article className="main_section_area">
              <div className="main_section_header">
                <h6>Contingency</h6>
              </div>
              {contingencyData?.data && contingencyData?.data?.length > 0 ? (
                <DataTable
                  value={contingencyData.data as DataForContingency[]}
                  size="small"
                  tableStyle={{ minWidth: "50rem" }}
                  className="page_table project_table p-0 p-sm-2"
                  rowHover
                  tableClassName="mb-1"
                  rowClassName={getRowClassName}
                  selectionMode="single"
                  metaKeySelection={false}
                  selection={selectedContingency}
                  onSelectionChange={(e) => setSelectedContingency(e.value)}
                  dataKey="id"
                  scrollable
                  scrollHeight={"75vh"}
                  emptyMessage="No data found"
                  footerColumnGroup={
                    <ColumnGroup>
                      <Row>
                        <Column
                          footerClassName="has_sub_footer"
                          footer="Sub total:"
                          colSpan={2}
                          className="table_column text_no_wrap text-end"
                        />
                        <Column
                          footerClassName="has_sub_footer"
                          footer={`${currencySymbol} ${formatPrice(
                            contingencyData?.contingency_total!
                          )}`}
                          className="table_column text_no_wrap text-end pe-sm-3"
                        />
                      </Row>
                      <Row>
                        <Column
                          footerClassName="sub_footer_column"
                          footer="Variation:"
                          colSpan={2}
                          className="table_column text_no_wrap text-end"
                        />
                        <Column
                          footerClassName="sub_footer_column"
                          footer={`${currencySymbol} ${formatPrice(
                            contingencyData?.variation_total!
                          )}`}
                          className="table_column text_no_wrap text-end pe-sm-3"
                        />
                      </Row>
                      <Row>
                        <Column
                          footerClassName="sub_footer_column last_row_first"
                          footer="Remaining contingencies:"
                          colSpan={2}
                          className="table_column text_no_wrap text-end"
                        />
                        <Column
                          footerClassName="sub_footer_column last_row_last"
                          footer={`${currencySymbol} ${formatPrice(
                            contingencyData?.contingency_total! -
                            contingencyData?.variation_total!
                          )}`}
                          className="table_column text_no_wrap text-end pe-sm-3"
                        />
                      </Row>
                    </ColumnGroup>
                  }
                >
                  <Column
                    header="Item no."
                    alignHeader={"center"}
                    body={(rowData: DataForContingency, { rowIndex }) => (
                      <span className="flex_center">
                        {String(rowIndex + 1).padStart(2, "0")}
                      </span>
                    )}
                    style={{ width: "15%" }}
                    className="table_column"
                  ></Column>

                  <Column
                    header="Item name"
                    body={(rowData: DataForContingency) => (
                      <span>
                        {rowData?.item_name ? rowData.item_name : "--"}
                      </span>
                    )}
                    style={{ width: "45%" }}
                    className="table_column name_text"
                  ></Column>

                  <Column
                    header="Amount"
                    alignHeader={"right"}
                    body={(rowData: DataForContingency) => (
                      <span className="flex-end text-end text_no_wrap">
                        {rowData?.amount
                          ? currencySymbol + " " + formatPrice(rowData.amount)
                          : "--"}
                      </span>
                    )}
                    style={{ width: "20%" }}
                    className="table_column text-end"
                  ></Column>
                </DataTable>
              ) : (
                <div className="no_content_added_area">
                  <img
                    src="/assets/images/no_data/no_data_img.png"
                    alt="No data!"
                  />
                  <p>
                    No contingency item(s) added, to add the variation click on
                    add button.
                  </p>
                </div>
              )}
            </article>
          </Fade>
        )}

        {/* Summary */}
        {showSummary && (
          <Fade duration={300} triggerOnce>
            <article className="main_section_area">
              <div className="main_section_header">
                <h6>Summary</h6>
              </div>

              {summaryData && summaryData !== null ? (
                <DataTable
                  value={summaryData?.section_data as SectionSummary[]}
                  size="small"
                  tableStyle={{ minWidth: "50rem" }}
                  className="page_table project_table view_only p-0 p-sm-2"
                  rowHover
                  tableClassName="mb-1"
                  rowClassName={getRowClassName}
                  emptyMessage="No data found"
                  footerColumnGroup={
                    <ColumnGroup>
                      <Row>
                        <Column
                          footerClassName="has_sub_footer"
                          footer="Sub total:"
                          colSpan={2}
                          className="table_column text_no_wrap text-end"
                        />
                        <Column
                          footerClassName="has_sub_footer"
                          footer={`${currencySymbol} ${formatPrice(
                            summaryData?.section_sub_total!
                          )}`}
                          className="table_column text_no_wrap text-end pe-sm-3"
                        />
                      </Row>
                      <Row>
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer="Gross total:"
                          colSpan={2}
                          className="table_column text_no_wrap text-end"
                        />
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer={`${currencySymbol} ${formatPrice(
                            summaryData?.gross_total!
                          )}`}
                          className="table_column text_no_wrap text-end pe-sm-3"
                        />
                      </Row>
                      <Row>
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer="Clients discretion draw:"
                          colSpan={2}
                          className="table_column text_no_wrap text_semi_bold text-end"
                        />
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer={`${currencySymbol} ${formatPrice(
                            summaryData?.client_discretion_draw!
                          )}`}
                          className="table_column text_semi_bold text_no_wrap text-end pe-sm-3"
                        />
                      </Row>
                      <Row>
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer="Sub total:"
                          colSpan={2}
                          className="table_column text_no_wrap text-end"
                        />
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer={`${currencySymbol} ${formatPrice(
                            summaryData?.sub_total!
                          )}`}
                          className="table_column text_no_wrap text-end pe-sm-3"
                        />
                      </Row>
                      <Row>
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer={`Less retention at ${summaryData?.less_retention_percentage + "%"
                            }:`}
                          colSpan={2}
                          className="table_column text_semi_bold text_no_wrap text-end"
                        />
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer={`${currencySymbol} ${formatPrice(
                            summaryData?.less_retention!
                          )}`}
                          className="table_column text_no_wrap text_danger text_semi_bold text-end pe-sm-3"
                        />
                      </Row>
                      <Row>
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer="Net total:"
                          colSpan={2}
                          className="table_column text_no_wrap text-end"
                        />
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer={`${currencySymbol} ${formatPrice(
                            summaryData?.net_total!
                          )}`}
                          className="table_column text_no_wrap text-end pe-sm-3"
                        />
                      </Row>
                      <Row>
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer={`Less previous payment ${summaryData?.before_valuation_edit_count !== null
                            ? "(Valuation " +
                            summaryData?.before_valuation_edit_count +
                            ")"
                            : ""
                            }:`}
                          colSpan={2}
                          className="table_column text_no_wrap text-end text_semi_bold"
                        />
                        <Column
                          footerClassName="sub_footer_column custom"
                          footer={`${currencySymbol} ${formatPrice(
                            summaryData?.less_previous_payment!
                          )}`}
                          className="table_column text_no_wrap text-end text_semi_bold pe-sm-3"
                        />
                      </Row>
                      <Row>
                        <Column
                          footerClassName="sub_footer_column last_row_first column_highlight"
                          footer={`Valuation ${summaryData?.valuation_edit_no
                            } (${formatDate(
                              summaryData?.valuation_edit_created
                            )}):`}
                          colSpan={2}
                          className="table_column text_no_wrap text-end"
                        />
                        <Column
                          footerClassName="sub_footer_column last_row_last column_highlight"
                          footer={`${currencySymbol} ${formatPrice(
                            summaryData?.final_total!
                          )}`}
                          className="table_column text_no_wrap text-end pe-sm-3"
                        />
                      </Row>
                    </ColumnGroup>
                  }
                >
                  <Column
                    field="item_no"
                    body={(rowData: SectionSummary, { rowIndex }) => (
                      <span className="flex_center">{rowIndex + 1}</span>
                    )}
                    className="table_column text-center"
                  ></Column>

                  <Column
                    field="section_name"
                    body={(rowData: SectionSummary) => (
                      <span>
                        {rowData.section_name ? rowData.section_name : "--"}
                      </span>
                    )}
                    className="table_column item_name_column name_text"
                  ></Column>

                  <Column
                    field="section_amount"
                    body={(rowData: SectionSummary) => (
                      <span className="flex-end text_no_wrap">
                        {rowData.section_amount != null
                          ? currencySymbol +
                          " " +
                          formatPrice(rowData.section_amount)
                          : "--"}
                      </span>
                    )}
                    className="table_column text-end"
                  ></Column>
                </DataTable>
              ) : (
                <div className="no_content_added_area">
                  <img
                    src="/assets/images/no_data/no_data_img.png"
                    alt="No data!"
                  />
                  <p>No data found!</p>
                </div>
              )}
            </article>
          </Fade>
        )}
      </div>

      {/* Note view modal */}
      <Dialog
        header={noteViewModalHeader}
        headerClassName="custom_modal_header"
        dismissableMask
        visible={showNoteViewModal}
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleCloseNoteViewModal}
      >
        <div className="custom_modal_body">
          <div className="custom_modal_body">
            <div className="row">
              <div className="col-12">
                {noteContent ? (
                  <React.Fragment>
                    <h6 className="note_title">{noteType}&nbsp;note: </h6>
                    <p className="note_text p-0 name_text">{noteContent}</p>
                  </React.Fragment>
                ) : (
                  <p className="note_text p-0 text-center text-secondary pt-3">
                    Click the edit button and add your note.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Note modify modal */}
      <Dialog
        header={noteModifyModalHeader}
        footer={noteModifyModalFooter}
        headerClassName="custom_modal_header"
        dismissableMask
        visible={showNoteModifyModal}
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleCloseNoteModifyModal}
      >
        <div className="custom_modal_body">
          <div className="custom_modal_body">
            <div className="col-12">
              <Textarea
                id="note"
                label="Note"
                labelHtmlFor="note"
                required={true}
                value={note}
                placeholder="Enter your note here"
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                  setNote(e.target.value)
                }
                error={noteError}
                formGroupClassName="mb-0"
              />
            </div>
          </div>
        </div>
      </Dialog>

      {/* Variation modal */}
      <Dialog
        visible={showVariationModal}
        header={variationModalHeader}
        footer={variationModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseVariationModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Variation number */}
              <div className="col-12 col-sm-4">
                <TextInput
                  id="variationNumber"
                  label="Variation no."
                  labelHtmlFor="variationNumber"
                  required={true}
                  value={variationNumber}
                  placeholder="Variation no."
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setVariationNumber(e.target.value)
                  }
                  error={variationNumberError}
                  keyFilter={"num"}
                  inputType="number"
                />
              </div>

              {/* Variation amount */}
              <div className="col-12 col-sm-8">
                <NumberInput
                  inputId="variationAmount"
                  label="Variation amount"
                  labelHtmlFor="variationAmount"
                  placeholder="Variation amount"
                  onChange={handleVariationAmountChange}
                  value={variationAmount}
                  required={true}
                  min={0}
                  prefix={currencySymbol + " "}
                  maxFractionDigits={2}
                  minFractionDigits={2}
                  error={variationAmountError}
                />
              </div>

              {/* Variation name */}
              <div className="col-12 col-sm-12">
                <TextInput
                  id="variationItemName"
                  label="Item name"
                  labelHtmlFor="variationItemName"
                  required={true}
                  value={variationItemName}
                  placeholder="Item name"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setVariationItemName(e.target.value)
                  }
                  error={variationItemNameError}
                />
              </div>

              {/* Variation file */}
              <div className="col-12">
                <FileInput
                  id="variationFile"
                  label="Add file"
                  labelHtmlFor="variationFile"
                  required={false}
                  value={variationFileName}
                  onUpload={handleVariationFileUpload}
                  onClear={handleClearVariationFile}
                  toast={toast}
                  error={variationFileError}
                  containerClassName="mb-0"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Contingencies modal */}
      <Dialog
        visible={showContingencyModal}
        header={contingencyModalHeader}
        footer={contingencyModalFooter}
        headerClassName="custom_modal_header"
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseContingencyModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Contingency name */}
              <div className="col-12 col-sm-12">
                <TextInput
                  id="contingencyItemName"
                  label="Item name"
                  labelHtmlFor="contingencyItemName"
                  required={true}
                  value={contingencyItemName}
                  placeholder="Item name"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setContingencyItemName(e.target.value)
                  }
                  error={contingencyItemNameError}
                />
              </div>

              {/* Contingency amount */}
              <div className="col-12 col-sm-8">
                <NumberInput
                  inputId="contingencyAmount"
                  label="Amount"
                  labelHtmlFor="contingencyAmount"
                  placeholder="Amount"
                  onChange={handleContingencyAmountChange}
                  value={contingencyAmount}
                  required={true}
                  min={0}
                  prefix={currencySymbol + " "}
                  maxFractionDigits={2}
                  minFractionDigits={2}
                  error={contingencyAmountError}
                  formGroupClassName="mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>

      {/* Document view modal */}
      <DocumentViewModal
        isOpen={showDocumentViewModal}
        onClose={handleCloseDocumentViewModal}
        fileUrl={documentPath!}
      />

      {/* Document download modal */}
      <DocumentDownload
        isOpen={showDownloadModal}
        onClose={() => setShowDownloadModal(false)}
        title="VALUATION"
        fileUrl={documentUrl}
        documentCreatedDate={selectedValuationEditData?.valuation_edit_created!}
        documentNumber={selectedValuationEditData?.valuation_edit_no}
      />
    </div>
  );
};

export default ValuationEdit;
